import { useState, useEffect, useContext } from 'react'
import { UserMeta } from '../data/user'
import api from '../api'
import { SessionContext } from '../contexts/SessionContext'

let _cachedUserMeta: UserMeta | undefined = undefined

export const useUserMeta = () => {
  const { loggedIn } = useContext(SessionContext)
  const [userMeta, setUserMeta] = useState<UserMeta | undefined>(_cachedUserMeta)

  useEffect(
    () => {
      // We will get a 401 error if we try to send a user meta request when not logged in.
      if (loggedIn !== true) return

      (async () => {
        const metaResp = await api.user.meta()
        if (metaResp.data.error !== false) {
          return
        }
        const meta = metaResp.data.data
        _cachedUserMeta = meta
        setUserMeta(meta)
      })();
    },
    [ setUserMeta, loggedIn ]
  )

  return userMeta
}
